import { lazy, type ReactElement } from 'react';

export interface Microsoft365ManagementRouteDefinition {
  capabilityPath: string;
  label: string;
  element: ReactElement;
}

export const AutoAttendantWizard = lazy(() =>
  import('./pages/AutoAttendantWizard').then((module) => ({
    default: module.AutoAttendantWizard,
  }))
);

export const MICROSOFT_365_MANAGEMENT_ROUTE_DEFINITIONS: readonly Microsoft365ManagementRouteDefinition[] = [
  {
    capabilityPath: '/callflows/auto-attendant/new',
    label: 'Auto Attendant Wizard',
    element: <AutoAttendantWizard />,
  },
];
